import { render, staticRenderFns } from "./NewsPopup.vue?vue&type=template&id=3db73115&"
import script from "./NewsPopup.vue?vue&type=script&lang=js&"
export * from "./NewsPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports